import React from "react";
import { Modal } from "reactstrap";

const ContactModal = ({ show, data, onClose }) => {
  if (!show) return null;

  return (
    <Modal isOpen={show} toggle={onClose} backdrop="static" keyboard={false}>
      <div className="modal-header">
        <h5 className="modal-title">View Contact Enquiry</h5>
        <button className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        <div className="row">
          <div className="mb-3 col-md-6">
            <label className="form-label">First Name*</label>
            <div className="form-control">
              {data?.FirstName}
            </div>
          </div>

          <div className="mb-3 col-md-6">
            <label className="form-label">Last Name*</label>
            <div className="form-control">
              {data?.LastName}
            </div>
          </div>

          <div className="mb-3 col-md-12">
            <label className="form-label">Email*</label>
            <div className="form-control">
              {data?.Email}
            </div>
          </div>

          <div className="mb-3 col-md-12">
            <label className="form-label">Contact Number*</label>
            <div className="form-control">
              {data?.Subject}
            </div>
          </div>

          <div className="mb-3 col-md-12">
            <label className="form-label">Message</label>
            <div
              className="form-control"
              style={{ minHeight: "120px", whiteSpace: "pre-wrap" }}
            >
              {data?.Message}
            </div>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default ContactModal;